import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { proofNoteSchema, ProofNoteSchema } from './proofFeedbackSchema';
import { ProofNoteInput } from './proof';
import styles from './ProofForms.module.scss';

interface ProofNoteFormProps {
  onSubmit: (input: ProofNoteInput) => Promise<boolean>;
}

// 쪽지: 담당자에게 자유롭게 문의하는 메시지. 시안 수정 횟수가 차감되지 않는다
function ProofNoteForm({ onSubmit }: ProofNoteFormProps) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<ProofNoteSchema>({
    resolver: zodResolver(proofNoteSchema),
  });

  const submit = async (values: ProofNoteSchema) => {
    if (await onSubmit(values)) reset();
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit(submit)}>
      <div className={styles.formHead}>
        <strong>쪽지 보내기</strong>
        <span>단순 문의 · 일정 확인 등은 쪽지로 남겨주세요. 수정 횟수가 차감되지 않습니다.</span>
      </div>

      <div className={styles.field}>
        <label htmlFor="noteMessage">쪽지 내용</label>
        <textarea id="noteMessage" rows={3} placeholder="담당자에게 전달할 내용을 입력해주세요." {...register('message')} />
        {errors.message && <p className={styles.error}>{errors.message.message}</p>}
      </div>

      <div className={styles.field}>
        <label htmlFor="noteAttachment">이미지 첨부 (선택)</label>
        <input id="noteAttachment" type="file" accept="image/*" {...register('attachment')} />
      </div>

      <button type="submit" className={styles.submit} disabled={isSubmitting}>
        {isSubmitting ? '보내는 중...' : '쪽지 보내기'}
      </button>
    </form>
  );
}

export default ProofNoteForm;
